export default "__VITE_ASSET__2a7f7f16__"